import { Component, OnInit, ViewChild, ChangeDetectorRef, HostListener, SimpleChanges } from '@angular/core';
import { MdbTableDirective, MdbTablePaginationComponent, ModalDirective } from 'angular-bootstrap-md';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { Clientes } from '../../cliente';
import { ProveedorService } from '../../proveedor.service';
import { validarRuc } from '../../validar-ruc';
import { validarCedula } from '../../validar-cedula';

@Component({
  selector: 'app-proveedor',
  templateUrl: './proveedor.component.html',
  styleUrls: ['./proveedor.component.scss']
})
export class ProveedorComponent  implements OnInit {
  clientes: Clientes[]= [];
  clienteActuliza: Clientes;
  listaClientesActulizar: Clientes[] = [];
  editForm: FormGroup;
  obligado:string;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective
  @ViewChild('processingModal') public mdbModal: ModalDirective;
  data: Clientes[] = [];
  previous: any = [];
  isLoadingResults = true;
  validaIdentificacion:boolean
  identificacion:string
  constructor(private alertService: AlertService,private api: ProveedorService, private cdRef: ChangeDetectorRef, private formBuilder: FormBuilder, private ruter: Router) { }
  searchText: string = '';
  @HostListener('input') oninput() {
    this.searchItems();
  }


  mensaje(codigo: string) {



    this.api.getCliente(codigo).subscribe((data: Clientes[]) => {
      console.log(data);
      data.forEach(item => {

        this.editForm.controls.nombrerazonsocial.setValue(item.nombrerazonsocial);
        this.editForm.controls.numeroidentificacion.setValue(item.numeroidentificacion);
        this.editForm.controls.direccion.setValue(item.direccion);
        this.editForm.controls.telefonoconvencional.setValue(item.telefonoconvencional);
        this.editForm.controls.celular.setValue(item.celular);
        this.editForm.controls.tipoCliente.setValue(item.tipoCliente);
        this.editForm.controls.codcliente.setValue(item.codcliente);
        console.log('codigo cliente' + item.codcliente);
        this.editForm.controls.tipoidentificacion.setValue(item.tipoidentificacion);
        this.editForm.controls.correo.setValue(item.correo);
      });





    }, err => {
      console.log(err);
      this.isLoadingResults = false;
    });
    this.mdbModal.show();


  }

  ngOnChanges(changes: SimpleChanges){
    console.log(changes);
}


onChangeObligado(newValue) {
  this.obligado=newValue
}
ngDoCheck(){


}


listarCliente(){

  this.api.getClientes(localStorage.getItem('id'))
  .subscribe((
    data: Clientes[]) => {
    this.clientes = data;
    console.log(this.clientes);
    this.mdbTable.setDataSource(this.clientes);
    this.mdbTable.dataSourceChange();
    this.previous = this.mdbTable.getDataSource();
  }
    , err => {
      console.log(err);
      this.isLoadingResults = false;
    });
}


  ngOnInit() {
    this.listarCliente();

    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ['', Validators.required],
      numeroidentificacion: [0, Validators.required],
      direccion: ['', Validators.required],
      telefonoconvencional: ['', Validators.required],
      celular: ['', Validators.required],
      correo: ['', Validators.required, Validators.email],
      tipoCliente: ['', Validators.required],
      codcliente: [0, Validators.required],
      tipoidentificacion: ['', Validators.required]
    });


  }
  eliminarCliente(id: number) {
    this.api.eliminarCliente(id).subscribe(

      data  => {
        this.alertService.success("Se elimino con exito..")
        this.listarCliente();

      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );

  }

  agregarCliente() {
    this.editForm = this.formBuilder.group({
      nombrerazonsocial: ['', Validators.required],
      numeroidentificacion: ['', Validators.required],
      direccion: ['', Validators.required],
      telefonoconvencional: ['', Validators.required],
      celular: ['', Validators.required],
      correo: ['', Validators.required],
      tipoCliente: ['', Validators.required],
      codcliente: [0, Validators.required],
      tipoidentificacion: ['', Validators.required]
    });

    this.mdbModal.show();
    this.listarCliente();
  }


  actulizarCliente() {
    this.clienteActuliza = new Clientes();
    this.clienteActuliza.nombrerazonsocial = this.editForm.controls.nombrerazonsocial.value;
    this.clienteActuliza.numeroidentificacion = this.editForm.controls.numeroidentificacion.value;
    this.clienteActuliza.direccion = this.editForm.controls.direccion.value;
    this.clienteActuliza.telefonoconvencional = this.editForm.controls.telefonoconvencional.value;
    this.clienteActuliza.celular = this.editForm.controls.celular.value;
    this.clienteActuliza.tipoCliente = this.editForm.controls.tipoCliente.value;
    this.clienteActuliza.codcliente = this.editForm.controls.codcliente.value;
    this.clienteActuliza.correo = this.editForm.controls.correo.value;
    this.clienteActuliza.tipoidentificacion = this.editForm.controls.tipoidentificacion.value;
    this.clienteActuliza.idEmisor = Number(localStorage.getItem('id'));
    this.clienteActuliza.enviado ='S';
    this.clienteActuliza.obligadoLlevarContabilidad =this.obligado
    this.listaClientesActulizar[0] = this.clienteActuliza;
    this.identificacion=this.clienteActuliza.numeroidentificacion.toString()
    if (this.identificacion.length<=10){
      if (validarCedula(this.identificacion)){
        this.validaIdentificacion=true;
      }

    }
    if (this.identificacion.length>10){
      if (validarRuc(this.identificacion)){
        this.validaIdentificacion=true;
      }

    }   
   if (this.validaIdentificacion==true){
   
    this.api.setActulizarCliente(this.listaClientesActulizar).subscribe(

      data  => {
        this.alertService.success("Se actualizo con exito..")
        this.mdbModal.hide();
        this.listarCliente();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
  
    }else{
      this.alertService.danger("Verifique Ruc o Cedula....")
      
    }

  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(5);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }


  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.clientes = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.clientes = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

}
